export default class Locale_SubSettingsAdministration { 
	SubSettings = {
		Deleted: "Sub settings deleted!",
		Saved: "Sub settings saved!",
	}
	ResetValue: string = "Reset to value from Root setting";
	DialogTitle: string = 'Sub setting';
}